module.exports = __webpack_public_path__ + "img/agent1.5e4f073a.png";